import { observer } from 'mobx-react';
import { useStore } from 'models/utils';
import React, { useCallback } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import drakeHappy from '../assets/drakeHappy.jpg';
import drakeSad from '../assets/drakeSad.jpg';
import SignInButton from '../components/SignInButton';
import TwoPhotosWithScore from '../components/TwoPhotosWithScore';
import { AppPageWrapper } from './AppPageWrapper';
import './LandingPage.css';
import { Routes } from '../constants';

const LandingPage: React.FC = observer(() => {
  const { currentUser } = useStore();
  const history = useHistory();

  const handleSignInClick = useCallback(() => {
    history.push(Routes.auth);
  }, [history]);

  if (currentUser.isAuthenticated) {
    return <Redirect to={Routes.play} />;
  }

  return (
    <AppPageWrapper>
      <div>
        <h1 className={'nes-text'}>Picsel</h1>
        <h4 style={{ marginTop: '20px' }}>selects the best picture for your dating profile</h4>
      </div>

      <div>
        <TwoPhotosWithScore isDisabled={true} rightUrl={drakeSad} leftUrl={drakeHappy} leftVotes={42} rightVotes={7} />
      </div>
      <button
        className={'nes-btn is-error'}
        onClick={currentUser.loginAnonymously}
        style={{ marginBottom: '20px', marginTop: '20px' }}
      >
        > Let's play!
      </button>

      <p>Played before?</p>
      <SignInButton onClick={handleSignInClick} />
    </AppPageWrapper>
  );
});

export default LandingPage;
